import { reportingApi } from "../../../api/apiClient";

function getCorzapReports() {
  return reportingApi.get("/staticReports");
}

function getCustomReports(userId) {
  return reportingApi.get(`/reports/${userId}`);
}
// Generate random string to avoid duplicate report name
function generateRandomString() {
  return Math.random().toString(36).substring(2, 15);
}

function saveCustomReport(userId, reportName, data, randomString = true) {
  const nameWithoutSpaces = reportName.replace(/\s/g, "-");
  //generateRandomString()
  return reportingApi
    .post(
      `/reports/${userId}/${nameWithoutSpaces}${
        randomString ? `_duplicate` : ""
      }`,
      {
        ...data,
        orderBy: data.orderBy ?? [],
        groupBy: data.groupBy ?? [],
      }
    )
    .then((res) => {
      console.log("done", res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      throw err;
    });
}

function updateCustomReport(userId, reportName, data) {
  return reportingApi.put(`/reports/${userId}/${reportName}`, {
    ...data,
    groupBy: data.groupBy ?? [],
    orderBy: data.orderBy ?? [],
  });
}

function getReportData(userId, reportName, filters) {
  const { pageSize, pageNumber, searchCriteria } = filters;

  return reportingApi.post(
    `/reportsData/${!!userId ? `${userId}/` : ""}${reportName}`,
    {
      pageSize,
      pageNumber,
      searchCriteria,
    }
  );
}

function getInitialReportData(filters) {
  const {
    pageSize,
    pageNumber,
    searchCriteria: { dateTimeTo, dateTimeFrom },
  } = filters;
  return reportingApi.post(`/initialReport`, {
    pageSize,
    pageNumber,
    searchCriteria: {
      dateTimeTo,
      dateTimeFrom,
    },
  });
}

function deleteCustomReport(userId, reportName) {
  return reportingApi.delete(`/reports/${userId}/${reportName}`);
}

export const reportingServices = {
  getCorzapReports,
  saveCustomReport,
  getCustomReports,
  getReportData,
  updateCustomReport,
  deleteCustomReport,
  getInitialReportData,
};
